// SPDX-License-Identifier: Apache-2.0
import GirafeHTMLElement from '../../base/GirafeHTMLElement';
import GirafeConfig from '../../tools/configuration/girafeconfig';
import { UsedInTemplateOnly } from '../../decorators';

class HeaderComponent extends GirafeHTMLElement {
  templateUrl = './template.html';
  styleUrls = ['./style.css'];

  public constructor() {
    super('header');
  }

  get config(): GirafeConfig {
    return this.context.configManager.Config;
  }

  @UsedInTemplateOnly()
  get logoSource(): string {
    if (this.state.interface.darkFrontendMode) {
      return this.config.branding.logoDarkMode;
    }
    return this.config.branding.logo;
  }

  @UsedInTemplateOnly()
  get logoAltText(): string {
    return `${this.config.branding.appTitle.toLowerCase().replaceAll(' ', '-')}-logo`;
  }

  private setHtmlMetaData() {
    const title = this.context.i18nManager.getTranslation(this.config.branding.appTitle);
    const description = this.context.i18nManager.getTranslation(this.config.branding.description);
    document.title = title;
    document.querySelector('meta[name="description"]')?.setAttribute('content', description);
  }

  registerEvents() {
    this.subscribe('language', () => this.setHtmlMetaData());
    if (!this.state.interface.isMobile) {
      this.subscribe('interface.darkFrontendMode', () => this.refreshRender());
    }
  }

  protected override connectedCallback() {
    super.connectedCallback();
    this.setHtmlMetaData();
    this.render();
    super.girafeTranslate();

    if (this.state.interface.isMobile) {
      // Header shouldn't be visible on mobile
      this.hide();
    }
    this.registerEvents();
  }
}

export default HeaderComponent;
